<div class="tour-stop-page d-flex justify-content-center bg-grey h-100" *ngIf="showLoadingTour || fetchingLocation || tourFinished">
  <div class="container-flud tour-container">
    <ng-container *ngIf="!tourFinished">
    <div class="row h-100 m-0" *ngIf="showLoadingTour">
      <div class="col-12 p-0">
        <app-loading-tour [loaded]="tourInfoLoaded" (continue)="handleContinue()"></app-loading-tour>
      </div>
    </div>
    <div class="row h-100 m-0" *ngIf="fetchingLocation && !tourService.fetchedLocation">
      <div class="col-12 p-0">
        <app-location-lottie-animation></app-location-lottie-animation>
        <app-location-permission [locationServicesOff]="!locationAllowed" (withOutGpsAllow)="continueWithoutGPS()">
        </app-location-permission>
      </div>
    </div>
    </ng-container>
    <div class="finish-page" *ngIf="tourFinished">
      <div @finished class="finish position-relative overflow-hidden bg-black">
        <div class="row justify-content-center h-100">
          <div class="col-12 text-center top">
            <a href="http://sonomaplazahistory.com" target="_blank" rel="noopener noreferrer">
              <img src="../../assets/city-hall.png" alt="Sonoma City Hall graphic">
            </a>
            <h3 class="text-center">Thank You!</h3>
          </div>
          <div class="bottom col-12 text-center pb-5">
            <div class="curve"></div>
            <h3 class="position-relative mb-0">Exit</h3>
            <p class="position-relative">Click to continue</p>
            <a class="d-block" [appNavigate]="['']"><button class="position-relative"><img src="../../assets/next-arrow.svg"></button></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="!tourFinished">
  <ng-container *ngIf="stopNumber === 0">
    <app-welcome-map [ngStyle]="{display: showWelcomeBox ? 'block' : 'none'}" (welcomeToMapBox)="closeWelcomeToMapBox()"
      *matches="'mobile'"></app-welcome-map>
  </ng-container>

  <!-- <div class="d-grid">
     <button type="button" class="btn btn-primary" (click)="handleArrived()">
       I've arrived
     </button>
   </div> -->
  <div class="map-page" *ngIf="!showStopInfo && !showLoadingTour && stopCoordinates.length" [ngClass]="(showLoadingTour || fetchingLocation) ? 'd-none': 'd-block'">
    <div class="map-page-center">
      <div class="container-flud">
       <app-page-layout layoutClass="map-layout">
        <div>
          <app-tour-map [currentStop]="stopNumber" [paths]="stopPaths" [stopCoordinates]="stopCoordinates" (mapLoad)="onMapLoad()"
            [language]="language" (trackedLocation)="handleTrackedLocation($event)">
          </app-tour-map>
        </div>
      </app-page-layout>
      </div>
      <div class=" px-0 stopCard" *ngIf="!showLoadingTour && !showStopInfo">
        <div class="card tour-stop-card">
          <img *matches="'desktop'" [src]="'../../assets/banners/desktop/banner'+(stopNumber+1)+'.png'"
            class="w-100 banner-img">
          <img *matches="'mobile'" [src]="'../../assets/banners/mobile/banner'+(stopNumber+1)+'.png'"
            class="w-100 banner-img">
          <div class="card-content d-flex flex-column">
            <h5>{{ 'stopCard.nextStop' | translate }}</h5>
            <h2>{{ banner[stopNumber][0] }}</h2>
            <h6>{{ infos[stopNumber][0].location || infos[stopNumber][0].title || banner[stopNumber][0] }}</h6>
            <button *matches="'desktop'" type="button" (click)="handleArrived(true)"><img src="../../assets/location.svg"
                alt="">{{ 'stopCard.continueButton' | translate }}</button>
            <button *matches="'mobile'" type="button" (click)="handleArrived(true)"><img src="../../assets/location.svg"
                alt="">{{ 'stopCard.arrivedButton' | translate }}</button>
          </div>
        </div>
      </div>
    </div>

  </div>

  <div *ngIf="showStopInfo && !showLoadingTour" class="map_info">
    <app-info
    class="row justify-content-center position-relative d-block  m-0"
    [stopNumber]="stopNumber"
    [narration]="narrations[stopNumber]"
    [audioHidden]="audioHidden"
    [info]="infos[stopNumber]"
    (changeState)="goToNextStop()"
    [language]="language"></app-info>
   </div>


  <div *ngIf="arrivedAtStop" class="arrived-container " @arrived>
    <div class="arrived">
      <div class="ratio"></div>
      <div class="blob container-fluid">
        <div class="row h-100 w-750">
          <div class="col-12 my-auto text-center pt-5">
            <img class="walking mb-4" src="../../assets/walking.svg">
            <h1 *ngIf="language == 'en'">You've Arrived!</h1>
            <h1 *ngIf="language == 'es'">¡Has llegado!</h1>
            <p *ngIf="language == 'en'" class="mt-4"><b>Click to continue</b></p>
            <p *ngIf="language == 'es'" class="mt-4"><b>He llegado</b></p>
            <a class="d-block mt-4 pt-3"><button (click)="goToInfoPage()"><img
                  src="../../assets/next-arrow.svg"></button></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
